module.exports = __webpack_public_path__ + "08eda92397aee9e52a40d431c3a28e5c.svg";